import { useTranslation } from 'react-i18next'

export function listingCardSoldCoverClass(baseClass: string, isSold?: boolean): string {
  return isSold ? `${baseClass} listing-card-cover--sold` : baseClass
}

export default function ListingCardSoldOverlay({ show }: { show?: boolean }) {
  const { t } = useTranslation()
  if (!show) return null
  return (
    <div className="listing-card-sold-overlay" aria-hidden="true">
      <span className="listing-card-sold-label">{t('seller.sold')}</span>
    </div>
  )
}
